import React, { Component } from 'react';
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  TablePagination,
  Card,
  CardContent,
  IconButton,
  CardActionArea,
  Fab
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Serverurl from './Apiurl';
import AddTerms from "./AddTerms";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
class Quotetermsconditions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      terms: [],
      totalItems: 0,
      page: 0,
      rowsPerPage: 5,
      tc_type: props.tc_type,
      confirmDialogVisible: false,
      deletingTerm: null,
      itemsPerPageOptions: [5, 10, 25, 50],
      logredirect: false,
      pagename: '',
      addTermsOpen: false,
    };
  }

  componentDidMount() {
    let type = this.props.tc_type ? parseInt(this.props.tc_type, 10) : null;

    if (!type) {
      const params = new URLSearchParams(window.location.search);
      type = parseInt(params.get('type'), 10) || 1;
    }

    this.setState({ tc_type: type, page: 0 }, this.fetchTerms);
  }

  componentDidUpdate(prevProps) {
    if (this.props.tc_type && this.props.tc_type !== prevProps.tc_type) {
      this.setState(
        { tc_type: parseInt(this.props.tc_type, 10), page: 0 },
        this.fetchTerms
      );
    }
  }

  fetchTerms = () => {
    const bu_id = localStorage.getItem("GBuserid");

    axios
      .get(
        `${Serverurl}ajaxtermsconditions.php?action=getall&StartIndex=${this.state.page}&PageSize=${this.state.rowsPerPage}&tc_type=${this.state.tc_type}&tc_bu_id=${bu_id}`
      )
      .then((res) => {
        const data = res.data;

        const filteredData = Array.isArray(data)
          ? data.filter(
              (item) => String(item.tc_type) === String(this.state.tc_type)
            )
          : [];

        const totalItems = filteredData?.[0]?.total
          ? parseInt(filteredData[0].total, 10)
          : filteredData.length;

        this.setState({ terms: filteredData, totalItems });
      })
      .catch((err) => {
        console.error("Error fetching terms:", err);
        this.setState({ terms: [], totalItems: 0 });
      });
  };

  onPageChange = (event, newPage) => {
    this.setState({ page: newPage }, this.fetchTerms);
  };

  onRowsPerPageChange = (event) => {
    this.setState(
      { rowsPerPage: parseInt(event.target.value, 10), page: 0 },
      this.fetchTerms
    );
  };

  openConfirmDeleteDialog = (id) => {
    this.setState({ confirmDialogVisible: true, deletingTerm: id });
  };

  closeConfirmDeleteDialog = () => {
    this.setState({ confirmDialogVisible: false, deletingTerm: null });
  };

  confirmDelete = () => {
    const { deletingTerm } = this.state;

    const formData = new FormData();
    formData.append('action', 'delete');
    formData.append('tc_id', deletingTerm);
    formData.append('userid', 1);

    axios.post(`${Serverurl}ajaxtermsconditions.php`, formData).then(() => {
      this.setState({ confirmDialogVisible: false, deletingTerm: null });
      this.fetchTerms();
    });
  };

  changeType = (type) => {
    this.setState({ tc_type: type, page: 0 }, this.fetchTerms);
  };

  render() {
    if (this.state.logredirect) {
      return <Navigate to={this.state.pagename} />;
    }

    const isLockedMode = Boolean(this.props.tc_type);

    return (
        <div className="formdisplay">
      <Box
  sx={{
    display: "flex",
    alignItems: "center",
    gap: 1,
    mb: 3,
    whiteSpace: "nowrap",
  }}
>
    <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>

  <Typography variant="h4">
    {isLockedMode
      ? Number(this.state.tc_type) === 1
        ? "Quotation Terms"
        : "Purchase Order Terms"
      : "Terms & Conditions"}
  </Typography>
</Box>


        {!isLockedMode && (
          <Box sx={{ display: 'flex', gap: 3, mb: 3 }}>
            <Typography
              onClick={() => this.changeType(1)}
              sx={{
                cursor: 'pointer',
                fontWeight: this.state.tc_type === 1 ? 600 : 400,
                borderBottom:
                  this.state.tc_type === 1 ? '2px solid #1976d2' : 'none',
                paddingBottom: '4px',
              }}
            >
              Quotation
            </Typography>

            <Typography
              onClick={() => this.changeType(2)}
              sx={{
                cursor: 'pointer',
                fontWeight: this.state.tc_type === 2 ? 600 : 400,
                borderBottom:
                  this.state.tc_type === 2 ? '2px solid #1976d2' : 'none',
                paddingBottom: '4px',
              }}
            >
              PO
            </Typography>
          </Box>
        )}

        <ul style={{ listStyle: 'none', padding: 0 }}>
          {this.state.terms.length > 0 ? (
            this.state.terms.map((term) => (
              <li key={term.tc_id} style={{ marginBottom: 16 }}>
                <Card elevation={3}>
                  <CardActionArea
                    onClick={() =>
                      this.props.onSelectTerms &&
                      this.props.onSelectTerms(term)
                    }
                  >
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        {term.tc_title}
                      </Typography>

                      <Typography
                        variant="body2"
                        color="text.secondary"
                        component="div"
                      >
                        <span
                          dangerouslySetInnerHTML={{ __html: term.tc_content }}
                        />
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </li>
            ))
          ) : (
            <Typography align="center">No records found</Typography>
          )}
        </ul>
{this.state.totalItems > 0 && (
        <TablePagination
          component="div"
          count={this.state.totalItems}
          page={this.state.page}
          onPageChange={this.onPageChange}
          rowsPerPage={this.state.rowsPerPage}
          onRowsPerPageChange={this.onRowsPerPageChange}
          rowsPerPageOptions={this.state.itemsPerPageOptions}
        />
		)}

        <Fab
          aria-label="add"
          onClick={() => this.setState({ addTermsOpen: true })}
          sx={{
            position: 'fixed',
            bottom: 30,
            right: 30,
            zIndex: 1000,
            backgroundColor: '#11408f',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#0d3476',
            },
          }}
        >
          Add
        </Fab>

        {/* ADD TERMS DIALOG */}
        <Dialog
          open={this.state.addTermsOpen}
          onClose={() => this.setState({ addTermsOpen: false })}
          fullWidth
          maxWidth="md" 
        >
         

          <DialogContent sx={{padding:'10px 5px'}}>
            <AddTerms
              quotationMode={this.state.tc_type}
              onTermAdded={(term) => {
                this.setState({ addTermsOpen: false });
                this.fetchTerms();
                if (this.props.onSelectTerms) {
                  this.props.onSelectTerms(term);
                }
              }}
            />
          </DialogContent>
        </Dialog>

        {/* CONFIRM DELETE DIALOG */}
        <Dialog
          open={this.state.confirmDialogVisible}
          onClose={this.closeConfirmDeleteDialog}
        >
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to delete this term?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeConfirmDeleteDialog}>Cancel</Button>
            <Button color="error" onClick={this.confirmDelete}>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Quotetermsconditions;